export default __webpack_public_path__ + "../staticImages/trauben_rot-260.png";